import { useQuery } from '@tanstack/react-query';
import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { TALENT_DROPDOWN_VALUES } from 'ui-components/dist/TalentDropdown';
import { SEARCH_CONTENT_CACHE_KEY_NAME } from '~/constants/search';
import { LocalStorageService } from '~/core/utils/storage';
import { searchApi } from '~/searchApi';
import { selectTalentManager } from '~/selectors/talent-manager';

import { mapQueryFromVmToApi } from './useContentSearch.mappers';
import { IContentSearchQuery } from './useContentSearch.types';

export interface IContentSearchProps {
  defaultQuery?: IContentSearchQuery;
  isEnabled?: boolean;
  ignoreRosterParam?: boolean;
}

export const useContentSearch = ({
  defaultQuery = {},
  isEnabled = true,
  ignoreRosterParam = false,
}: IContentSearchProps = {}) => {
  const [query, setQuery] = useState<IContentSearchQuery>(defaultQuery);
  const manager = useSelector(selectTalentManager);
  const isAgencyEnabled = !!manager?.agency?.enabled;

  const selectedRoster = LocalStorageService.getItem<string>('talentOption');

  const roster: any = useMemo(() => {
    return (selectedRoster === TALENT_DROPDOWN_VALUES.agency &&
      isAgencyEnabled) ||
      !manager
      ? undefined
      : TALENT_DROPDOWN_VALUES.self;
  }, [selectedRoster, isAgencyEnabled, manager]);

  const { data, ...useQueryProps } = useQuery(
    [SEARCH_CONTENT_CACHE_KEY_NAME, query],
    () =>
      searchApi.getContents(
        mapQueryFromVmToApi({
          ...defaultQuery,
          ...query,
          roster: ignoreRosterParam ? undefined : roster,
        }),
      ),
    { enabled: isEnabled },
  );

  return {
    ...useQueryProps,
    contents: data?.data ?? [],
    query,
    setQuery,
    totalItems: data?.meta.total,
    lastPage: data?.meta.last_page,
  };
};
